import { render, staticRenderFns } from "./IconCircleCheck.vue?vue&type=template&id=13012cbe&functional=true&"
import script from "./IconCircleCheck.vue?vue&type=script&lang=js&"
export * from "./IconCircleCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports